var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supply"},[(_vm.facility=='app')?_c('div',{staticClass:"app"},[_c('App',{attrs:{"barList":_vm.barlist}})],1):_c('div',[_c('Pc',{attrs:{"barList":_vm.barlist}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }